import { MENU_ITEMS, HORIZONTAL_MENU_ITEMS, MenuItemTypes } from '../constants/menu';
import { IN_MENU_ITEMS, IN_HORIZONTAL_MENU_ITEMS } from '../constants/inmenu';
import { OPD_MENU_ITEMS, OPD_HORIZONTAL_MENU_ITEMS } from '../constants/opdmenu';

const loginUser: any = sessionStorage.getItem('admin_user');
const filterMenuItems = (menuItems: any, apiData: any) => {
    return menuItems
        .map((item: any) => {
            const matchingApiItem = apiData.find((apiItem: any) => apiItem.uniqueKey === item.uniqueKey);
            if (matchingApiItem) {
                // If there is a match, include it and check for children recursively
                const filteredChildren = filterMenuItems(item.children || [], apiData);
                return {
                    ...item,
                    //...matchingApiItem,
                    children: filteredChildren.length > 0 ? filteredChildren : null,
                };
            }
            // If no match, exclude it
            return null;
        })
        .filter(Boolean); // Remove null values from the array
};

const getMenuItems = () => {
    const navigation = { key: 'navigation', label: 'Navigation', isTitle: true };
    // NOTE - You can fetch from server and return here as well
    //const filteredMenuItems = filterMenuItems(MENU_ITEMS, apiData);
    //return [navigation, ...filteredMenuItems];
    const newData = JSON.parse(loginUser);
    let menuItems;

    switch (newData?.Role) {
        case 'OPD':
            menuItems = OPD_MENU_ITEMS;
            break;
        default:
            menuItems = MENU_ITEMS;
            break;
    }

    return menuItems;
};

const getHorizontalMenuItems = () => {
    // NOTE - You can fetch from server and return here as well
    const newData = JSON.parse(loginUser);
    let menuItems;

    switch (newData?.Role) {
        case 'OPD':
            menuItems = OPD_HORIZONTAL_MENU_ITEMS;
            break;
        default:
            menuItems = HORIZONTAL_MENU_ITEMS;
            break;
    }

    return menuItems;
};

const findAllParent = (menuItems: MenuItemTypes[], menuItem: MenuItemTypes): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemTypes[] | undefined,
    menuItemKey: MenuItemTypes['key'] | undefined
): MenuItemTypes | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

const findBreadcrumb = (
    menuItems: MenuItemTypes[] | undefined,
    targetLabel: string,
    breadcrumb: string[] = []
): any => {
    if (menuItems && targetLabel) {
        for (const item of menuItems) {
            breadcrumb.push(item.label);
            if (item.label === targetLabel) {
                return breadcrumb.join('->');
            }
            if (item.children && item.children.length > 0) {
                const result = findBreadcrumb(item.children, targetLabel, breadcrumb);
                if (result) {
                    return result;
                }
            }
            breadcrumb.pop(); // Remove the last item if the current item is not the target
        }
    }
    return null;
};

type MenuItem = {
    [key: string]: any;
};

const transformKeys = (obj: MenuItem | MenuItem[]): MenuItem | MenuItem[] => {
    if (Array.isArray(obj)) {
        return obj.map((item) => transformKeys(item));
    } else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
            // Change 'Key' to 'key' and convert its value to a string if it's a number
            const newKey = key === 'Key' ? 'key' : key;
            const newValue =
                key === 'Key' && typeof obj[key] === 'number' ? obj[key].toString() : transformKeys(obj[key]); // Recursively transform keys for nested objects
            (acc as any)[newKey] = newValue; // Type assertion to handle dynamic property assignment
            return acc;
        }, {} as MenuItem); // Initial value typed as MenuItem
    }
    return obj;
};

export { getMenuItems, getHorizontalMenuItems, findAllParent, findMenuItem, findBreadcrumb, transformKeys };
